import { IRadObject, Property, RadObject, RadObjectPropertyValues } from "../RadObject";
import { NAMESPACE } from "./_Namespace";

export type ExpressionPropertyValues =
    RadObjectPropertyValues
    & {
    };

export type ExpressionProperties = {
    [name in keyof ExpressionPropertyValues]: Property<ExpressionPropertyValues[name]>
};

export interface IExpression extends IRadObject, ExpressionProperties
{
}

export abstract class Expression<TPropertyValues extends ExpressionPropertyValues = ExpressionPropertyValues> extends RadObject<TPropertyValues> implements IExpression
{
    public static override classNamespace = NAMESPACE + "Expression";
    public static override className = "Expression";

    // #region Overrides

    protected override __initializeProperties(propertyValues: TPropertyValues)
    {
        super.__initializeProperties(propertyValues);
    }

    // #endregion
}

